module.exports = __webpack_public_path__ + "static/oyelaran-06043a03ef99703696440222c3e03a4d.png";